import { gql } from '@apollo/client';

/* ----------------------- GraphQL (fetch ALL sub images) --------------------- */
export const GET_ALL_SUB_IMAGES = gql`
  query SkuSubImagesAll($id: String!, $limitItems: Int = 100, $limitImages: Int = 12) {
    productCardStoreCollection(where: { id: $id }, limit: 1) {
      items {
        id
        description {
          json
        }
        energySticker
        energyImage {
          url
        }
        energyInfoLink
        showDynamicDiscountLabel
        itemsCollection(limit: $limitItems) {
          items {
            __typename
            ... on SubProductCardStore {
              id
              originalPrice
              imagesCollection(limit: $limitImages) {
                items {
                  image {
                    url
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export type ImageAsset = { url: string; title?: string };

export type ProductCardExtra = {
  id: string;
  showDynamicDiscountLabel?: boolean;
  itemsCollection: {
    items: Array<{
      id: string;
      imagesCollection: {
        items: Array<ImageAsset>;
      };
    }>;
  };
};

export type ProductCardsExtra = {
  productCardStoreCollection: {
    items: Array<ProductCardExtra>;
  };
};

export const GET_PRODUCT_CARDS_EXTRAS = gql`
  query ProductImages($ids: [String!]!, $limitItems: Int = 35, $limitImages: Int = 1) {
    productCardStoreCollection(where: { id_in: $ids }) {
      items {
        id
        showDynamicDiscountLabel
        itemsCollection(limit: $limitItems) {
          items {
            __typename
            ... on SubProductCardStore {
              id
              imagesCollection(limit: $limitImages) {
                items {
                  image {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
